import React, { Component } from 'react';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import { dateTimeFormat, timeFormat } from '../../utilities/timeUtility';
import ScrollBox from '../../components/ScrollBox';
import Translation from '../../utilities/localizationUtility';

class Index extends Component {
  constructor(props) {
    super(props);

    this.state = {
      timeSlots: [],
      termSelected: props.termSelected,
    };
  }

  static getDerivedStateFromProps(nextProps, prevstate) {
    const { flattenTimeSlots, termSelected, settings } = nextProps;
    let timeSlots = flattenTimeSlots.filter(x => x.term_id === termSelected.id);
    if (settings.setting
      && settings.setting.max_number_of_events
      && parseInt(settings.setting.max_number_of_events, 10)
      && timeSlots.length) {
      timeSlots = timeSlots.slice(0, parseInt(settings.setting.max_number_of_events, 10));
    }

    if (settings.setting
      && settings.setting.max_number_of_months
      && parseInt(settings.setting.max_number_of_months, 10)
      && timeSlots.length) {
      const firstSlot = timeSlots[0];
      const finishDate = moment(firstSlot.start).add(parseInt(settings.setting.max_number_of_months, 10), 'M');
      timeSlots = timeSlots.filter(x => moment(x.start) < finishDate);
    }

    return { timeSlots, termSelected };
  }

  uniqSlots(slots) {
    let result = [];
    const map = new Map();
    for (const slot of slots) {
      if(!map.has(slot.id)){
        map.set(slot.id, true);
        result.push(slot);
      }
    }
    return result;
  }

  render() {
    const { settings } = this.props;
    const { timeSlots, termSelected } = this.state;

    const { timeZone } = window.bta;

    const t = new Translation(settings);

    let slots = this.uniqSlots(timeSlots);

    return (
      <ScrollBox height="100%" color={settings.style.price.color}>
        <p className="letter-spacing text-center fz13">
          {moment.tz(termSelected.start_date, timeZone).format(dateTimeFormat(true, false))}
          {' - '}
          {moment.tz(termSelected.finish_date, timeZone).format(dateTimeFormat(true, false))}
        </p>
        <ul style={{ padding: '5px 15px' }}>
          {slots.length ? (
            slots.map(x => (
              <li
                key={x.id}
                className="flexbox space-between"
                style={{
                  padding: '0 5px 10px',
                  opacity: moment.tz(x.start, timeZone).isBefore() ? 0.6 : 1,
                  letterSpacing: '1px',
                  fontSize: '15px',
                  lineHeight: 1.5,
                }}
              >
                <span>{moment.tz(x.start, timeZone).format('ddd, MMM DD, YYYY')}</span>
                <span>
                  {moment.tz(x.start, timeZone).format(timeFormat())}
                  {' - '}
                  {moment.tz(x.finish, timeZone).format(timeFormat())}
                </span>
              </li>
            ))
          ) : (
            <li className="flexbox space-between text-center" style={{ padding: '5px' }}>
              {t.key('noClass')}
            </li>
          )}
        </ul>
      </ScrollBox>
    );
  }
}

Index.propTypes = {};

export default connect(({ frames, order, settings }) => ({
  flattenTimeSlots: frames.flattenTimeSlots,
  termSelected: order.termSelected,
  settings,
}))(Index);
